import { Fragment } from 'react';

import cx from 'classnames';

import { ProTip } from '../ProTip/ProTip';
import { QuestionHeading } from '../QuestionHeader/QuestionHeader';

import styles from './question.module.less';

export type QuestionProps = {
  /** Optional content that appears before the header */
  preHed?: React.ReactNode;
  hed: React.ReactNode;
  instructions?: React.ReactNode;
  /** Type of HTML element to use for the question instructions, defaults to p. */
  instructionsComponent?: keyof React.ReactHTML;
  children?: React.ReactNode;
  proTip?: React.ReactNode;
  isRedesignedInquiryFlow?: boolean;
};

export const Question = ({
  preHed,
  hed,
  instructions,
  children,
  instructionsComponent: Instructions = 'p',
  proTip,
  isRedesignedInquiryFlow,
}: QuestionProps): JSX.Element => {
  return (
    <Fragment>
      {preHed}
      <QuestionHeading isRedesignedInquiryFlow={isRedesignedInquiryFlow}>{hed}</QuestionHeading>
      {instructions && (
        <Instructions
          className={cx(styles.question, { [styles.redesignQuestion]: isRedesignedInquiryFlow })}
        >
          {instructions}
        </Instructions>
      )}
      {!instructions && !isRedesignedInquiryFlow && <div className={styles.questionPlaceholder} />}
      {children}
      {proTip && <ProTip>{proTip}</ProTip>}
    </Fragment>
  );
};

export default Question;
